import {IWatcher, EWatcherFieldFlag} from 'components/report-configuration/hooks/use-form-fields-manager';

export interface ICreateDocumentUploadTemplateWatchersProps{
    isEditingForm: boolean;
    mainFields: string[];
    disabledByEditingModeCondition?: {condition: () => boolean; flag: EWatcherFieldFlag};
}

export const createDocumentUploadTemplateWatchers = ({
    isEditingForm,
    mainFields,
}: ICreateDocumentUploadTemplateWatchersProps) => ({
    ...(() => Object.fromEntries([
        ...mainFields,
    ].map(fieldName => [fieldName, [{
        condition: () => !isEditingForm,
        flag: EWatcherFieldFlag.isDisabled,
    }]])))(),
} as {[index: string]: IWatcher[]});

export const createDffSegmentValues = (values: [string, unknown][]) => {
    const dffSegmentValues: {
        [columnName: string] : {
            segmentColumnName: string;
            segmentValue: any;
        };
    } = {};
    values.forEach(value => {
        if (!Array.isArray(value[1])) {
            dffSegmentValues[value[0]] = {
                segmentColumnName: value[0],
                segmentValue: value[1],
            };
        }
    });
    return dffSegmentValues;
};
